import React from 'react';

const Card = ({ header, footer, children, className = '' }) => {
  return (
    <div className={`bg-white dark:bg-gray-900 shadow-md rounded-lg overflow-hidden ${className}`}>
      {header && (
        <div className="bg-gray-100 px-6 py-4 border-b border-gray-200 text-lg font-semibold">
          {header}
        </div>
      )}
      <div className="px-6 py-4">{children}</div>
      {footer && (
        <div className="bg-gray-100 px-6 py-4 border-t border-gray-200 text-sm">
          {footer}
        </div>
      )}
    </div>
  );
};

export default Card;
